import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import Characters from "../pages/characters/page";
import CharacterDetail from "../pages/character/[id]/page";
import Works from "../pages/works/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "characters", element: <Characters /> },
      { path: "character/:id", element: <CharacterDetail /> },
      { path: "works", element: <Works /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;